module.exports = __webpack_public_path__ + "static/img/pressure-img.79ab2912.png";